'use client';

import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ServicePillarsSection from './components/ServicePillarsSection';
import TransformationSection from './components/TransformationSection';
import TechnologySection from './components/TechnologySection';
import GallerySection from './components/GallerySection';
import FinalCTASection from './components/FinalCTASection';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';

export default function Homepage() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <main className="bg-black text-white min-h-screen">
      <Header />
      <HeroSection />
      <ServicePillarsSection />
      <TransformationSection />
      <TechnologySection />
      <GallerySection />
      <FinalCTASection />
      <Footer />
    </main>
  );
}